import { Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export const StyledTooltip = withStyles({
  tooltip: {
    fontSize: "14px",
    backgroundColor: "black",
  },
})(Tooltip);

export default StyledTooltip;
